<template>
  <div class="jumbotron">
    <p class="lead">You need to be authorized to see requested page.</p>
    <hr class="my-4">
    <p class="lead">
      <button class="btn btn-lg btn-success"
              @click="authenticate('kaeuferportal')">
              Log In
      </button>
    </p>
  </div>
</template>

<style>
  .login {
    display: flex;
    flex-direction: column;
    width: 300px;
    padding: 10px;
  }
</style>

<script>
import {AUTH_REQUEST, AUTH_ERROR, AUTH_FORBIDDEN} from '@/store/actions/auth'

export default {
  name: 'login',
  methods: {
    authenticate: function (provider) {
      this.$auth.authenticate(provider)
        .then((resp) => {
          this.$store.dispatch(AUTH_REQUEST, resp).then(() => {
            // After successfull login
            // Go to 'AssignmentTermsDashboard' if no redirectPath value is set
            this.$router.replace(localStorage.getItem('redirectPath') || { name: 'AssignmentTermsDashboard' })

            // Delete the item from the local storage so that it is not accidently used in future (if you the user went directly to the login page on next auth for instance)
            localStorage.removeItem('redirectPath')
          })
        })
        .catch(err => {
          if (err.status) {
            return this.$store.dispatch(AUTH_FORBIDDEN, err).then(() => {
              this.$router.push({ name: 'InsufficientPermissionsPage' })
            })
          }
          this.$store.dispatch(AUTH_ERROR, err)
        })
    }
  }
}
</script>
